// 사용자 공개 식별자 유틸. 외부 URL·API 경로에는 불변 UUID public_id만 사용한다.
// 채팅 내부 신원(user_id)은 CHAT 계약 유지 대상이라 이 유틸을 쓰지 않는다.

const toIdString = (value) => {
    if (value === undefined || value === null) return null;
    const str = String(value).trim();
    return str === "" ? null : str;
};

// 프로필 URL·API 경로에 쓸 공개 식별자. public_id가 없으면 null.
export const getPublicUserKey = (entity) => toIdString(entity?.public_id);

// 두 사용자 payload가 같은 사용자인지 public_id로 비교한다.
export const isSameUser = (a, b) => {
    const aId = getPublicUserKey(a);
    return aId !== null && aId === getPublicUserKey(b);
};

// 라우트 param(:userId)이 세션 사용자를 가리키는지 비교한다.
export const matchesUserParam = (entity, param) => {
    const paramId = toIdString(param);
    return paramId !== null && paramId === getPublicUserKey(entity);
};
